import QRCode from "qrcode";

function roundRect(ctx, x, y, width, height, radius, fill) {
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
  ctx.fillStyle = fill;
  ctx.fill();
}

// 本地合成高清分享图，二维码直接编码原问卷链接，不依赖远程图片或截图。
export async function buildQuestionnairePoster(link) {
  if (!link) throw new Error("问卷链接未生成");
  const canvas = document.createElement("canvas");
  canvas.width = 750;
  canvas.height = 1060;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("当前浏览器不支持生成分享图");
  const background = ctx.createLinearGradient(0, 0, 0, 1060);
  background.addColorStop(0, "#0874ca");
  background.addColorStop(0.45, "#4ba8e0");
  background.addColorStop(1, "#e8f7ff");
  ctx.fillStyle = background;
  ctx.fillRect(0, 0, 750, 1060);
  ctx.fillStyle = "rgba(255,255,255,0.08)";
  ctx.beginPath(); ctx.arc(730, 70, 190, 0, Math.PI * 2); ctx.fill();
  ctx.beginPath(); ctx.arc(20, 240, 110, 0, Math.PI * 2); ctx.fill();

  const text = (value, y, size, color, weight = "normal") => {
    ctx.textAlign = "center";
    ctx.textBaseline = "middle";
    ctx.font = `${weight} ${size}px "Microsoft YaHei", "PingFang SC", sans-serif`;
    ctx.fillStyle = color;
    ctx.fillText(value, 375, y);
  };
  text("三高修复 · 健康重启", 88, 42, "#ffffff", "bold");

  ctx.save();
  ctx.shadowColor = "rgba(12,91,147,0.16)";
  ctx.shadowBlur = 28;
  ctx.shadowOffsetY = 12;
  roundRect(ctx, 50, 218, 650, 726, 32, "#ffffff");
  ctx.restore();
  text("扫码填写健康问卷", 280, 34, "#163b5c", "bold");
  text("开启健康评估", 328, 23, "#6b8395");

  roundRect(ctx, 135, 370, 480, 480, 22, "#f0f7fc");
  // 整数像素绘制二维码模块，保留四模块白边，避免缩放模糊影响识别。
  const qr = document.createElement("canvas");
  const modules = QRCode.create(link, { errorCorrectionLevel: "M" }).modules.size;
  await QRCode.toCanvas(qr, link, {
    errorCorrectionLevel: "M",
    margin: 4,
    scale: Math.max(1, Math.floor(448 / (modules + 8))),
    color: { dark: "#102b40", light: "#ffffff" },
  });
  ctx.imageSmoothingEnabled = false;
  ctx.drawImage(qr, Math.floor((750 - qr.width) / 2), 370 + Math.floor((480 - qr.height) / 2));
  text("微信扫一扫  /  长按识别二维码", 889, 25, "#1677c8", "bold");
  text("请如实填写个人信息及健康情况", 987, 23, "#476d87");
  text("此二维码用于健康问卷填写", 1022, 20, "#6b879b");
  return canvas.toDataURL("image/png");
}
